import React, { useEffect, useState } from 'react';
// @mui
import { Box, Grid, MenuItem, Stack, Typography, styled } from '@mui/material';
// hooks
import useLocales from '../../../hooks/useLocales';
// components
import Image from '../../../components/Image';
import { useSelector } from '../../../redux/store';
import CustomModal from '../../../components/CustomModal';
import { CardTitleAlt } from '../../GlobalStyles';

const Label = styled(Typography)(({ theme }) => ({
  color: '#fff',
  fontSize: 11,
  fontWeight: 700,
  textAlign: 'center',
  lineHeight: 'normal',
}));

const ItemContainerWrapper = styled(Box)(({ theme, isActive }) => ({
  padding: '1px',
  background: isActive ? 'linear-gradient(165.34deg, rgb(0, 199, 199) -17.16%, rgb(19, 38, 216) 91.36%)' : 'none',
  borderRadius: '8px',
}));

const ItemContainer = styled(Box)(({ theme, isActive }) => ({
  background: isActive ? 'rgb(6, 28, 69)' : 'rgb(8, 15, 28)',
  border: '1px solid rgb(37, 52, 73)',
  borderRadius: '8px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  textAlign: 'center',
  padding: theme.spacing(1),
  gap: theme.spacing(1),
}));

// ----------------------------------------------------------------------

export default function LanguagePopover({ sx = {}, CustomBtn, PopoverProps = {}, isSideNav = false }) {
  const { allLangs, currentLang, onChangeLang } = useLocales();

  const { siteSettings } = useSelector((x) => x.lookup);

  const [customLangs, setCustomLangs] = useState([]);

  const [open, setOpen] = useState(null);

  const [selectedLang, setSelectedLang] = useState(currentLang);

  const domainLocale = process.env.REACT_APP_LOCALE;

  const langStorage = localStorage.getItem('i18nextLng');

  const { translate } = useLocales();

  useEffect(() => {
    // setCustomLangs(allLangs.filter((f) => f.value === 'en' || f.value === domainLocale));
    if (siteSettings?.languages?.length > 0) {
      const matchingLangs = allLangs;
      // I JUST COMMENT THIS TEMPORARILY
      // .filter((obj1) =>
      //   siteSettings?.languages.some((obj2) => obj1.value === obj2.locale)
      // );

      if (matchingLangs) {
        setCustomLangs(matchingLangs);

        if (matchingLangs.findIndex((ml) => ml.value === langStorage) === -1) {
          handleChangeLang(matchingLangs.find((f) => f.value === domainLocale)?.value);
          console.log('matching');
        }
      } else {
        console.log('No Matching languages');
      }
    }
  }, [siteSettings?.languages]);

  const handleOpen = (event) => {
    setOpen(event.currentTarget);
  };

  const handleClose = () => {
    setOpen(null);
  };

  const handleChangeLang = (newLang) => {
    // localStorage.setItem('i18nextLng', newLang);
    onChangeLang(newLang);
    handleClose();
    window.location.reload();
  };

  return (
    <>
      <Box sx={{ display: 'flex', alignItems: 'center' }} onClick={(e) => handleOpen(e)}>
        {isSideNav ? (
          <Stack alignItems="center">
            <Image
              disabledEffect
              src={selectedLang.icon}
              alt={selectedLang.label}
              sx={{
                width: '32px',
                height: '32px',
                img: { objectFit: 'contain' },
              }}
            />
            <Label>{translate('change_language')}</Label>
          </Stack>
        ) : (
          <Stack sx={{ flex: 1 }} direction={'row'} spacing={2}>
            {CustomBtn ? (
              React.cloneElement(CustomBtn, { title: selectedLang?.label })
            ) : (
              <Image
                disabledEffect
                src={selectedLang.icon}
                alt={selectedLang.label}
                sx={{ width: isSideNav ? 25 : 22, height: isSideNav ? 25 : 22, borderRadius: '50%' }}
              />
            )}
          </Stack>
        )}
      </Box>

      {/* <MenuPopover */}
      <CustomModal
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleClose}
        maxWidth={'xs'}
        {...PopoverProps}
        PaperPropsSx={{ borderRadius: { xs: 1, sm: 0 }, overflow: { xs: 'hidden', sm: 'unset' } }}
      >
        <Box
          sx={{
            background: 'linear-gradient(0deg, rgb(7, 20, 44) -5.86%, rgb(38, 58, 89) 104.05%)',
            width: '100%',
            height: '100%',
          }}
        >
          <Box sx={{ display: 'flex', width: '100%', justifyContent: 'center' }}>
            <CardTitleAlt sx={{ fontSize: 14 }}>{translate('change_language')}</CardTitleAlt>
          </Box>
          <Box sx={{ p: 1, mt: 1 }}>
            <Grid container spacing={1}>
              {customLangs.map((option) => (
                <Grid item xs={4} key={option.value}>
                  <ItemContainerWrapper isActive={option.value === currentLang.value}>
                    <ItemContainer
                      isActive={option.value === currentLang.value}
                      onClick={() => {
                        if (!option?.isFake) {
                          handleChangeLang(option.value);
                          setSelectedLang(option);
                        }
                        handleClose();
                      }}
                    >
                      <Box sx={{ width: '28px', height: '28px', borderRadius: '50%', overflow: 'hidden' }}>
                        <Image
                          disabledEffect
                          alt={option.label}
                          src={option.icon}
                          sx={{ width: '100%', height: '100%' }}
                          placeholderRatio={'1/1'}
                        />
                      </Box>

                      {option.label}
                    </ItemContainer>
                  </ItemContainerWrapper>
                </Grid>
              ))}
            </Grid>
          </Box>
        </Box>
      </CustomModal>
      {/* </MenuPopover> */}
    </>
  );
}
